<aside class="side-nav" [class.active]="showHideSideNav === true">
  <div class="side-nav-top">
    <div class="logo">
      <img src="{{shopInfo?.siteLogo ?? 'assets/images/brand/logo/trustpointpharma.png'}}" alt="" />
      <div class="address" *ngIf="selectedAddress || (address && address.length)">
        <button>
          <h2>
            <i class="fa-solid fa-location-dot"></i>
          </h2>
          <p><span class="deliver">Deliver to</span> <span class="area-address"> {{ selectedAddress ?
              (selectedAddress?.area?.name) : (address[0]?.area?.name ? address[0]?.area?.name : 'N/A')}},
              {{ selectedAddress ? (selectedAddress?.division?.name) : (address[0]?.division?.name ?
              address[0]?.division?.name : 'N/A')}}</span></p>
        </button>

      </div>
    </div>
  </div>
  <div class="side-nav-middle">
    <ul>
      <li>
        <a href="/" (click)="onNavigate()" routerLink="/">
          <i class="fa-solid fa-house"></i>
          <span>Home</span>
        </a>
      </li>

      <li>
        <a href="/categories" routerLink="/categories">
          <i class="fas fa-bars"></i>
          <span>Categories</span>
        </a>
      </li>
      <li>
        <a href="/product-list" routerLink="/product-list">
          <span><i class="fa-solid fa-bag-shopping"></i></span>
          <span>Products</span></a>
      </li>

      <li>
        <a href="/blogs" routerLink="/blogs">
          <i class="fa fa-edit"></i>
          <span>Blog</span></a>
      </li>

      <li>
        <a href="/account/orders" routerLink="/account/orders">
          <svg width="17px" height="17px" focusable="false" viewBox="0 0 24 24" class="MuiSvgIcon-root">
            <path
              d="M19 5v14H5V5h14m1.1-2H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM11 7h6v2h-6V7zm0 4h6v2h-6v-2zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7z">
            </path>
          </svg>
          <span> {{userService.getUserStatus() ? 'Order Tracking' : 'Order Tracking'}} </span>
        </a>
      </li>

      <li>
        <a href="/coming-soon" routerLink="/coming-soon">
          <i class="fa-solid fa-user-doctor"></i>
          <span>Online Doctor</span></a>
      </li>
      <li>
        <a href="/coming-soon" routerLink="/coming-soon">
          <i class="fa-solid fa-person-dots-from-line"></i>
          <span>Online Diagnosis</span></a>
      </li>

      <li>
        <button type="button" (click)="openUploadPrescription()">
          <i class="fa-solid fa-cloud-arrow-up"></i>
          <span>Upload Prescription</span>
        </button>
      </li>

      <li *ngIf="shopInfo?.socialLinks && shopInfo?.socialLinks.length > 0">
        <a [href]="shopInfo?.socialLinks[0]?.value" target="_blank" rel="noopener">
          <i class="fas fa-star"></i>
          <span>Facebook Page</span>
        </a>
      </li>

      <li>
        <a href="/contact-us" routerLink="/contact-us">
          <i class="fas fa-phone-alt"></i>
          <span>Contact Us</span>
        </a>
      </li>

    </ul>
  </div>

  <div class="side-nav-bottom" *ngIf="shopInfo?.phones && shopInfo?.phones[0]?.value">
    <ul>
      <li>
        <a [href]="'tel:' + shopInfo?.phones[0]?.value">
          <i class="fas fa-phone-alt"></i>
          <span>Call for order</span>
        </a>
      </li>
    </ul>
  </div>

</aside>

<div class="side-nav-overlay" *ngIf="showHideSideNav === true" (click)="onHideSlide()"></div>
